<template>
  <button
    type="button"
    class="flex w-fit items-center active:outline active:outline-2 active:outline-offset-1"
    :class="[textColorClass(), customClass]"
    @click="$emit('click')"
  >
    <span
      :class="`material-icons-${iconStyle} text-text-${textSize} mr-0.5 font-bold`"
      aria-hidden="true">
      {{ iconName }}
    </span>
    <span :class="[`text-text-${textSize}`, {'underline': defaultUnderlined}]" class="hover:underline">{{ text }}</span>
  </button>
</template>

<script setup lang="ts">
const props = defineProps({
  text: {
    type: String,
    default: ''
  },
  textSize: {
    type: String,
    default: 'md'
  },
  iconName: {
    type: String,
    default: ''
  },
  iconStyle: {
    type: String,
    default: 'round'
  },
  color: {
    type: String,
    default: 'blue'
  },
  customClass: {
    type: String,
    default: ''
  },
  defaultUnderlined: {
    type: Boolean,
    default: false
  }
})

defineEmits(['click'])

function textColorClass() {
  switch (props.color) {
    case 'red':
      return 'text-red-300'
    case 'white':
      return 'text-white'
    default:
      return 'text-blue-400'
  }
}
</script>